import React, { useState } from 'react';
import '../styles/bans.scss';

const PRESETS = [
    { label: '12 ساعة', days: 0, hours: 12 },
    { label: 'يوم', days: 1, hours: 0 },
    { label: '3 أيام', days: 3, hours: 0 },
    { label: 'أسبوع', days: 7, hours: 0 },
    { label: 'شهر', days: 30, hours: 0 },
];

// Temporary ban with a duration and a reason (the driver sees the reason). Used by the
// "حالات الباند" page and the drivers page. `onSubmit({ days, hours, reason })` returns true on success.
const TempBanModal = ({ driver, extend = false, onClose, onSubmit }) => {
    const [days, setDays] = useState(extend ? 1 : 3);
    const [hours, setHours] = useState(0);
    const [reason, setReason] = useState(extend && driver?.tempBanReason ? driver.tempBanReason : '');
    const [saving, setSaving] = useState(false);

    const total = (Number(days) || 0) * 24 + (Number(hours) || 0);
    const canSave = total > 0 && reason.trim() && !saving;

    const submit = async () => {
        if (!canSave) return;
        setSaving(true);
        const ok = await onSubmit({ days: Number(days) || 0, hours: Number(hours) || 0, reason: reason.trim() });
        setSaving(false);
        if (ok) onClose();
    };

    return (
        <div className="ban-modal-overlay" onClick={() => !saving && onClose()}>
            <div className="ban-modal" onClick={(e) => e.stopPropagation()}>
                <h2>{extend ? 'تعديل مدة الإيقاف' : 'إيقاف مؤقت'}</h2>
                <p className="muted">
                    {driver?.driverName} {driver?.driverNumber ? <span className="num">#{driver.driverNumber}</span> : null}
                    {extend ? ' · تبدأ المدة الجديدة من الآن' : ''}
                </p>

                <label className="field-label">المدة</label>
                <div className="preset-row">
                    {PRESETS.map((p) => (
                        <button
                            key={p.label}
                            type="button"
                            className={`chip ${Number(days) === p.days && Number(hours) === p.hours ? 'active' : ''}`}
                            onClick={() => { setDays(p.days); setHours(p.hours); }}
                        >
                            {p.label}
                        </button>
                    ))}
                </div>
                <div className="duration-row">
                    <label>
                        أيام
                        <input type="number" min="0" max="365" value={days} onChange={(e) => setDays(e.target.value)} />
                    </label>
                    <label>
                        ساعات
                        <input type="number" min="0" max="23" value={hours} onChange={(e) => setHours(e.target.value)} />
                    </label>
                </div>

                <label className="field-label">السبب (يظهر للسائق)</label>
                <textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300} placeholder="مثال: تكرار إلغاء الرحلات بعد قبولها" />

                <div className="modal-actions">
                    <button type="button" className="btn ghost" onClick={onClose} disabled={saving}>إلغاء</button>
                    <button type="button" className="btn danger" onClick={submit} disabled={!canSave}>
                        {saving ? 'جارٍ الحفظ...' : extend ? 'حفظ المدة' : 'إيقاف السائق'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TempBanModal;
